/*
//-------------------------------------------------------
//   Copyright (c) 2019 Templa Computer Systems Ltd
//
//   App:        EmployeePortal.UI
//   Object:     App
//   Details:    App
//
// Log      Date   By  Scan Description
// -----  -------- --- ---- ------------------------------
// 101885 26/06/19 AJ  M01  Added Links
// 101879 02/07/19 JC  M02  Added new to /myrequests_copy/detail private route
// 102715 15/08/19 JC  M03  Added Contacts
// 104759 21/11/19 JC  M04  Whole menu now soft-coded
// 103782 10/12/19 JC  M05  Added MyTraining
// 105726 16/01/19 JC  M06  M04 change - allow access to change password if not logged in
// 106380 30/04/20 JC  M07  Added ManagerPortal / PortalRedirect page, login route with authentication ticket
// 103839 13/05/20 JC  M08  Added TeamPortal redirect
// 108958 24/08/20 JC  M09  Added applyFrameKiller in render
// WI3713 24/01/24 JC  M10JC    Added data forms
//-------------------------------------------------------
*/
import React, { Component } from 'react';
import { Route } from 'react-router';
import { withRouter } from 'react-router-dom';
import { PrivateRoute } from './components/PrivateRoute';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { configActions } from './store/ClientConfiguration';
import { alertActions } from './store/Alerts';
import { printViewActions } from './store/PrintView';
import { utils } from './utils/utils'; //M09
import Layout from './components/Layout';
import Loading from './components/Loading';
import Login from './pages/Login';
import Logout from './pages/Logout';
import Notices from './pages/Notices';
import Documents from './pages/Documents';
import MyPay from './pages/MyPay';
import MyDetails from './pages/MyDetails';
import MyPlan from './pages/MyPlan';
import MyRequests from './pages/MyRequests';
import Request from './pages/Request';
import SiteCalendar from './pages/SiteCalendar';
import Authenticate from './pages/Authenticate';
import ForgotPassword from './pages/ForgotPassword';
import ChangePassword from './pages/ChangePassword';
import PasswordChanged from './pages/PasswordChanged';
import Contacts from './pages/Contacts'; //M03
import MyTraining from './pages/MyTraining'; //M05
import PortalRedirect from './pages/PortalRedirect'; //M07
import DataForm from './pages/DataForm'; //M10JC


class App extends Component {
    constructor(props) {
        super(props);

        props.requestClientConfig();
    }

    render() {

        //M09 apply frame killer
        utils.applyFrameKiller();

        //get the root default path
        var rootDefaultPath = Login;

        //go through each menu entry in turn and try and get the default root path depending on what's enabled
        if (this.props.systemControl.configuration) {
            if (this.props.systemControl.configuration.epNoticesEnabled === true) {
                rootDefaultPath = Notices;
            } else if (this.props.systemControl.configuration.epDocumentsEnabled === true) {
                rootDefaultPath = Documents;
            } else if (this.props.systemControl.configuration.epMyPayEnabled === true) {
                rootDefaultPath = MyPay;
            } else if (this.props.systemControl.configuration.epMyDetailsEnabled === true) {
                rootDefaultPath = MyDetails;
            } else if (this.props.systemControl.configuration.epMyPlanEnabled === true) {
                rootDefaultPath = MyPlan;
            } else if (this.props.systemControl.configuration.epMyRequestsEnabled === true) {
                rootDefaultPath = MyRequests;
            } else if (this.props.systemControl.configuration.epMyTrainingEnabled === true) { //M05
                rootDefaultPath = MyTraining;
            } else if (this.props.systemControl.configuration.epContactsEnabled === true) {
                rootDefaultPath = Contacts;
            } else if (this.props.systemControl.configuration.epChangePasswordEnabled === true) {
                rootDefaultPath = ChangePassword;
            } 
        };

        return (
            this.props.clientConfiguration.isLoading
                ? <Loading />
                : <Layout
                    isNavbarVisible={this.props.authentication.loggedIn && !this.props.printView.item}
                    alerts={this.props.alerts.alerts}
                    clear={this.props.clear}
                    systemControl={this.props.systemControl} //M04
                    authentication={this.props.authentication} //M07
                    printViewItem={this.props.printView.item}
                    closeView={this.props.hide}
                >
                    <Route path='/login' exact component={Login} />{/*M07 added exact due to below*/}
                    <Route path='/login/ssoAuthenticationTicket/:ssoAuthenticationTicket?' component={Login} /> {/*M07 for passed in sso authentication ticket*/}
                    <Route path='/forgotPassword' component={ForgotPassword} />
                    <PrivateRoute exact path='/' component={rootDefaultPath} /> {/*M04 default path now soft coded*/}
                    <PrivateRoute path='/authenticate' component={Authenticate} />

                    {this.props.systemControl.configuration && this.props.systemControl.configuration.epDocumentsEnabled ?
                        <PrivateRoute path='/documents' exact component={Documents} />
                        : [] /* M04 only add route if enabled */}

                    {this.props.systemControl.configuration && this.props.systemControl.configuration.epDocumentsEnabled ?
                        <PrivateRoute path='/documents/:usePrevPageArgs' component={Documents} />
                        : [] /* M04 only add route if enabled */}

                    {this.props.systemControl.configuration && this.props.systemControl.configuration.epMyPayEnabled ?
                        <PrivateRoute path='/mypay' component={MyPay} />
                        : [] /* M04 only add route if enabled */}

                    {this.props.systemControl.configuration && this.props.systemControl.configuration.epMyDetailsEnabled ?
                        <PrivateRoute path='/mydetails' component={MyDetails} />
                        : [] /* M04 only add route if enabled */}

                    {this.props.systemControl.configuration && this.props.systemControl.configuration.epMyPlanEnabled ?
                        <PrivateRoute path='/myplan' exact component={MyPlan} />
                        : [] /* M04 only add route if enabled */}

                    {this.props.systemControl.configuration && this.props.systemControl.configuration.epMyPlanEnabled ?
                        <PrivateRoute path='/myplan/site/:siteId/:site/:year?/:month?' component={SiteCalendar} />
                        : [] /* M04 only add route if enabled */}

                    {this.props.systemControl.configuration && this.props.systemControl.configuration.epMyRequestsEnabled ?
                        <PrivateRoute path='/myrequests' exact component={MyRequests} />
                        : [] /* M04 only add route if enabled */}

                    {this.props.systemControl.configuration && this.props.systemControl.configuration.epMyRequestsEnabled ?
                        <PrivateRoute path='/myrequests/detail/:requestId/:date?' component={Request} />
                        : [] /* M04 only add route if enabled */}

                    {this.props.systemControl.configuration && this.props.systemControl.configuration.epDocumentsEnabled ?
                        <PrivateRoute path='/myrequests_copy/detail/:requestId/:date?/:copyfromid?' component={Request} /> /* M02 new private route */
                        : [] /* M04 only add route if enabled */}
   
                    {this.props.systemControl.configuration &&
                        (!this.props.systemControl.configuration.epChangePasswordEnabled ||
                            this.props.systemControl.configuration.epChangePasswordEnabled === true) ?
                        <PrivateRoute path='/changepassword' component={ChangePassword} />
                        : [] /* M04 only add route if enabled - M06 or not logged in as may need access before log in */}

                    <PrivateRoute path='/logout' component={Logout} />
                    <PrivateRoute path='/passwordchanged' component={PasswordChanged} />

                    {this.props.systemControl.configuration && this.props.systemControl.configuration.epContactsEnabled ?
                        <PrivateRoute path='/contacts' component={Contacts} /> /* M03 */
                        : [] /* M04 only add route if enabled */}
        
                    {this.props.systemControl.configuration && this.props.systemControl.configuration.epNoticesEnabled ?
                        <PrivateRoute path='/notices' component={Notices} /> /* M04 */
                        : [] /* M04 only add route if enabled */}

                    {this.props.systemControl.configuration && this.props.systemControl.configuration.epMyTrainingEnabled ?
                        <PrivateRoute path='/mytraining' component={MyTraining} /> /* M05 */
                        : [] /* only add route if enabled */}

                    {(this.props.systemControl.configuration && this.props.systemControl.configuration.epManagerPortalEnabled &&
                        this.props.authentication && this.props.authentication.user && this.props.authentication.user.isEnabledForMP) ||
                        (this.props.systemControl.configuration && this.props.systemControl.configuration.epTeamPortalEnabled &&
                            this.props.authentication && this.props.authentication.user && this.props.authentication.user.isEnabledForTP)?
                        <PrivateRoute path='/portalredirect/:portalredirecttype?' component={PortalRedirect} /> /* M07 M08 */
                        : [] /* only add route if enabled, both on system control & users */}

                    <PrivateRoute path='/dataform/:ownerId/:ownerType' component={DataForm}/* M10JC */ />
                </Layout>
        );
    }
}

export default withRouter(connect(
    state => state,
    dispatch => bindActionCreators({ ...configActions, ...alertActions, ...printViewActions }, dispatch)
)(App));